import { useEffect } from 'react';

import { Divider } from '@treezor/design-system';

import { useAppDispatch } from '@/hooks/redux-helpers';

import { KycGlobalStatus } from '@/features/kyc/components/kyc-infos/KycGlobalStatus';
import { KycVigilanceMeasure } from '@/features/kyc/components/kyc-infos/KycVigilanceMeasure';
import { getKYCProfilePayins } from '@/features/kyc/store/actions/kyc-profile.actions';
import { useKycInfos } from '@/features/kyc/hooks/useKycInfos';

export const KycInfos = () => {
  const dispatch = useAppDispatch();
  const { validationDate, user, hasAdditionalVigilanceMeasureBlock } = useKycInfos();
  useEffect(() => {
    dispatch(getKYCProfilePayins(user.userId));
  }, [dispatch, user.userId]);

  return (
    <div className="grid grid-cols-[auto_auto_1fr] gap-7 items-center bg-gradient-to-r from-blue-400/10 to-green-200/10 p-6 border-secondary border rounded-200">
      <KycGlobalStatus />
      {hasAdditionalVigilanceMeasureBlock && (
        <>
          <Divider direction="vertical" variant="secondary" />
          <KycVigilanceMeasure userId={user.userId} validationDate={validationDate} />
        </>
      )}
    </div>
  );
};
